import { useState, useRef, forwardRef, useImperativeHandle, memo } from 'react';
import Button from '@mui/material/Button';
import {

    Box,
    Grid2 as Grid,
    DialogTitle,
    ButtonGroup,
    Tooltip,
    Typography,
    IconButton,
    Chip
} from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import { checkComponentPresence, getSelectedElement, myTimestampToDate, propComparator } from '../utils/ui_utils';
import { useEvent } from '../context/eventContext';
import { differenceInMonths, format } from 'date-fns';
import { globalstyles } from '../lib/definitions';
import _ from 'lodash';
import { MyCloseBtn } from '../components/MyButtons';
import { getCowLight } from '../definitions/cow';
import { BorderBottom, BorderTopRounded, Info, Visibility, VisibilityOff, Warning } from '@mui/icons-material';
import { PublicCowDialog } from './PublicCowDialog';
import { CowtypeBadge } from '../components/CowtypeButton';
import { PropertyButton } from '../definitions/property';

import { advance_data_entry, common_data_entry, other_data_entry, mother_data_entry, lifetime_data_entry } from '../definitions/cow';
import { MyBadge } from '../components/graphicElements';
import { getPointData } from '../definitions/match';


export const newmatch = {
    match_name: '',
    match_description: '',
    match_type: 'normal',
    cow_list: [],
    award_list: [],
    has_partial: false,
    planned_start: new Date()
}

const getSumData = (m) => {
    const cl = []
    const aw_pos_id = m.result_list[0].id
    for (const cow of m.result_list[0].cow_list) {
            let award_list = []
        if (cow.cow) {

            const aw_cow = getSelectedElement(cow.cow.id, m.cow_list, 'id')
            console.log(aw_cow)
            for (const aw_id in aw_cow.award_dict) {
                const real_aw_id = aw_id.split("_")[1]
                if (real_aw_id !== aw_pos_id) {
                    const aw = aw_cow.award_dict[aw_id]
                    console.log("aw", aw)
                    if (aw.position >= 0) {
                        award_list.push({ ...aw, ...getSelectedElement(real_aw_id, m.award_list, 'id') })
                    }
                }
            }
        }
        console.log("AWARD LIST", award_list)
        cl.push({
            ...cow,
            cow: {
                ...cow.cow,

                award_list: award_list.sort(propComparator("order"))
            }
        })
    }
    return { cow_list: cl.filter(c => !c.cow?.squalified), has_position: true, id: aw_pos_id, name: "classifica (riassunto)", show_not_classified: true }

}


export const AwardListPointDialog = forwardRef(({ element_list, cow_list, is_public }, ref) => {
    const [open, setOpen] = useState(false);
    const [curElement, setCurElement] = useState({ ...newmatch })
    const [cur_award, setCurAward] = useState(0)
    const [award_result_list, setAwardResultList] = useState([])
    const publicRef = useRef()

    const [showZero, setShowZero] = useState(true)
    const [not_completed, setNotCompleted] = useState(0)

    useImperativeHandle(ref, () => {
        return {
            onEdit(el, i) {
                setOpen(true);
                console.log("OPEN DATA", el)
                let _el = { ...newmatch, ...el }
                setCurElement(_el)
                setCurAward(0)
                initSublist(_el)
            }
        }
    })


    const handleClose = () => {
        setOpen(false);
    };

    const cowdata_list = [...common_data_entry, ...advance_data_entry, ...other_data_entry, ...lifetime_data_entry, ...mother_data_entry]

    const handleShow = (c) => {
        publicRef.current.onShow(c)
    }


    const initSublist = (el) => {

        let filtered_list = []

        if (el.result_list) {
            if (el.result_list.length > 1) {
                filtered_list.push(getSumData(el))
            }
            for (const a of el.result_list) {
                const snc = a.has_position && (!is_public || (!is_public && !a.hide_not_qualified))
                console.log("SNC", a.has_position, !is_public, !a.hide_not_qualified)
                if (a.filter_data_list && a.filter_data_list.length > 0) {
                    for (const f of a.filter_data_list.sort()) {
                        if (f === 'all') {
                            filtered_list.push({ cow_list: a.cow_list.filter(c => !c.cow?.squalified), has_position: a.has_position, id: a.id, name: a.award_name, subname: 'tutti', show_not_classified: snc })
                        } else if (f === 'red') {
                            filtered_list.push({ cow_list: a.cow_list.filter(c => !c.cow?.squalified).filter(c => c.cow && c.cow.cow_type === 'red'), has_position: a.has_position, id: a.id, name: a.award_name, subname: 'red', show_not_classified: false })
                        } else if (f === 'black') {
                            filtered_list.push({ cow_list: a.cow_list.filter(c => !c.cow?.squalified).filter(c => c.cow && c.cow.cow_type === 'black'), has_position: a.has_position, id: a.id, name: a.award_name, subname: 'black', show_not_classified: false })
                        } else {
                            filtered_list.push({ cow_list: a.cow_list.filter(c => !c.cow?.squalified).filter(c => c.cow && c.cow[f] === true), has_position: a.has_position, id: a.id, name: a.award_name, subname: f, show_not_classified: false })
                        }
                    }
                } else {
                    if (a.from_other_data) {
                        filtered_list.push({ cow_list: el.cow_list.filter(c => c.award_dict[el.id + "_" + a.id]?.position >= 0).map(c => ({ cow: c, position_id: 0 })), show_not_classified: snc, has_position: a.has_position, id: a.id, name: a.award_name, award_value: a.award_value, award_label: getSelectedElement(a.award_value, cowdata_list, 'id')?.label })
                    } else {
                        filtered_list.push({ cow_list: a.cow_list, show_not_classified: snc, has_position: a.has_position, id: a.id, name: a.award_name })
                    }
                }
            }
        }
        if (el.source_list_data) {
            filtered_list = [...filtered_list, ...getPointData(el, element_list, cow_list, setNotCompleted)]
        } else {
            setNotCompleted(0)
        }

        setAwardResultList(filtered_list)
    }



    return (
        <div>

            <PublicCowDialog ref={publicRef} />
            <Dialog open={open} onClose={handleClose} maxWidth="md" fullScreen={true}>
                <DialogTitle>
                    <Grid container>
                        <Grid size="grow">
                            Risultati gara: &nbsp;
                            <b>{curElement.match_name}</b>
                        </Grid>
                        <Grid size="auto" sx={{ textAlign: "right" }}>
                            {award_result_list[cur_award]?.auto_sum &&
                                <ButtonGroup size="small">
                                    <span style={{ fontSize: '0.8em', border: '1px solid black', paddingRight: 10, paddingLeft: 10, borderTopLeftRadius: 5, borderBottomLeftRadius: 5, }}>
                                        soggetti con 0 punti
                                    </span>
                                    <Button variant={showZero ? 'contained' : 'outlined'} onClick={() => setShowZero(true)} startIcon={<Visibility />}>visualizza</Button>
                                    <Button variant={!showZero ? 'contained' : 'outlined'} onClick={() => setShowZero(false)} startIcon={<VisibilityOff />}>nascondi</Button>
                                </ButtonGroup>
                            }
                        </Grid>

                        <Grid size="auto">
                            <Grid style={{ textAlign: 'center', border: '1px solid #9c27B0', borderTopLeftRadius: 4, borderTopRightRadius: 4, borderBottom: '0px' }}>
                                <Typography sx={{ fontSize: '0.5em' }}>
                                    premi assegnati in questa gara
                                </Typography>
                            </Grid>
                            <Grid>
                                <ButtonGroup color="secondary" size="small">
                                    {award_result_list.map((a, k) => (
                                        <Button key={k} variant={cur_award === k ? 'contained' : 'outlined'} onClick={() => setCurAward(k)}>{a.subname || a.name} </Button>
                                    ))}
                                </ButtonGroup>
                            </Grid>
                        </Grid>
                        <Grid size={"auto"} sx={{ color: 'red', textAlign: 'center' }}>
                            {not_completed > 0 && <>
                                <Warning sx={{ fontSize: '1em' }} /> <b>Dati parziali</b> <br />{not_completed}&nbsp;
                                {not_completed === 1 ?
                                    <>
                                        gara precedente non ancora completata
                                    </>
                                    :
                                    <>
                                        gare precedenti non ancora completate
                                    </>
                                }
                            </>}
                        </Grid>
                    </Grid>
                    {award_result_list.length > 0 &&
                        award_result_list[cur_award].auto_sum ?

                        <Grid container sx={globalstyles.listHeader}>
                            <Grid size={1}>
                                Catalogo
                            </Grid>
                            <Grid size={1} flexDirection={"row"} container>
                                Matricola
                            </Grid>
                            <Grid size={1}>
                                parti
                            </Grid>
                            <Grid size={1}>
                                Età (mesi)
                            </Grid>
                            <Grid size={1}>
                                Data di nascita
                            </Grid>
                            <Grid size={"grow"}>
                                Posizione
                            </Grid>
                            <Grid size={1}>
                                Punteggio
                            </Grid>
                            <Grid size={0.5}>
                                &nbsp;
                            </Grid>
                        </Grid>
                        :
                        <Grid container sx={globalstyles.listHeader}>
                            <Grid size={0.5}>
                                Pos
                            </Grid>
                            <Grid size={0.5}>
                                Catalogo
                            </Grid>
                            <Grid size={1} flexDirection={"row"} container>
                                Matricola
                            </Grid>
                            <Grid size={"grow"}>
                                Nome
                            </Grid>
                            <Grid size={"grow"}>
                                Proprietà
                            </Grid>
                            <Grid size={1}>
                                parti
                            </Grid>
                            <Grid size={1}>
                                Età (mesi)
                            </Grid>
                            <Grid size={1}>
                                Data di nascita
                            </Grid>
                            {award_result_list[cur_award]?.award_value &&
                                <Grid size={1}>
                                    {award_result_list[cur_award]?.award_label}
                                </Grid>
                            }
                            <Grid size={0.5}>
                            </Grid>
                        </Grid>
                    }
                </DialogTitle>
                <DialogContent>
                    {award_result_list.length > 0 ?
                        <>
                            <OneAwardRender a={award_result_list[cur_award]} showZero={showZero} handleShow={handleShow} cow_list={curElement.cow_list} />
                        </>
                        :
                        <>
                            nessun risultato presente
                        </>
                    }
                </DialogContent>
                <DialogActions>
                    <MyCloseBtn handleClose={handleClose} />
                </DialogActions>
            </Dialog>
        </div>
    );
})



const OneAwardRender = ({ a, showZero, handleShow, cow_list }) => {
    if (a.auto_sum) {
        return (
            a && a.data_list?.filter(p => showZero || p.total_point > 0).map((p, k) => (
                <OneGroupedData property={p} key={k} showZero={showZero} handleShow={handleShow} />
            ))
        )

    } else {
        return (
            <>
                {a && a.cow_list.length === 0 &&
                    <>
                        nessun soggetto classificato
                    </>
                }
                {a.cow_list?.map((cow, k) => (
                    <OneCow cow={cow.cow} key={k} index={k} handleShow={handleShow} award_value={a.award_value} />
                ))}

                {a && a.show_not_classified &&
                    <NotMatchCows match_cow_list={a.cow_list ? a.cow_list : undefined} cow_list={cow_list} handleShow={handleShow} />
                }

            </>

        )

    }
}

const OneGroupedData = memo(({ property, showZero, handleShow }) => {
    return (
        <>
            <Grid container sx={globalstyles.sectionHeader}>
                <Grid size="grow">
                    {property.name}
                </Grid>
                <Grid size={1}>
                    <Tooltip title={<>

                        <Typography>
                            da regolamento
                        </Typography>
                        <Typography sx={{ fontSize: '1em' }}>
                            (max 6 soggetti)
                        </Typography>
                        <Typography sx={{ fontWeight: 'bold' }}>
                            {property.total_point}
                        </Typography>
                        {property.real_total_point && property.total_point !== property.real_total_point &&
                            <>

                                <Typography sx={{ fontSize: '1.2em', borderTop: '1px solid white' }}>
                                    Punteggio Totale
                                </Typography>
                                {property.real_total_point}
                            </>
                        }
                    </>
                    }>
                        <span>
                            {property.total_point}
                            {property.real_total_point && property.total_point !== property.real_total_point &&
                                <span style={{ fontSize: '0.7em', marginLeft: 5 }}>({property.real_total_point})</span>
                            }
                        </span>
                    </Tooltip>
                </Grid>
                <Grid size={0.5}>
                    &nbsp;
                </Grid>
            </Grid>
            {property.cow_list.filter(c => showZero || c.match_point > 0).map((c, ck) => (
                <OneSumCow cow={c} key={ck} index={ck} handleShow={handleShow} />
            ))}
        </>
    )
})




const OneCow = memo(({ cow, index, handleShow, award_value }) => {
    const { selEvent } = useEvent()
    if (cow && cow.id) {

        const birthdate = myTimestampToDate(cow.birthdate)
        const ev_date = myTimestampToDate(selEvent.event_start)

        return (
            <Grid container sx={{ ...globalstyles.list_row, fontSize: '0.7em' }}>
                <Grid size={0.5}>
                    {index !== undefined &&
                        <Chip size="small" label={index + 1} />
                    }
                </Grid>
                <Grid size={0.5}>
                    {cow.catalog_id}
                </Grid>
                <Grid size={1} flexDirection={"row"} container>
                    {cow.cow_type === 'red' ?
                        <Tooltip placement="right" title="red">
                            <Box sx={{ backgroundColor: 'red', minWidth: '10px', mr: 0.2 }}>&nbsp;</Box>
                        </Tooltip>
                        :
                        <Tooltip placement="right" title="black">
                            <Box sx={{ backgroundColor: 'black', minWidth: '10px', mr: 0.2 }}>&nbsp;</Box>
                        </Tooltip>
                    }
                    {cow.serial}
                </Grid>
                <Grid size="grow">
                    {cow.name}
                </Grid>
                <Grid size="grow">
                    {cow.property &&
                        <PropertyButton element={cow.property} />
                    }
                </Grid>
                <Grid size={1}>
                    {cow.birth}
                </Grid>
                <Grid size={1}>
                    {differenceInMonths(ev_date, birthdate)}
                </Grid>
                <Grid size={1}>
                    {format(birthdate, 'dd/MM/yyyy')}
                </Grid>
                {award_value &&
                    <Grid size={1}>
                        {cow[award_value]}
                    </Grid>
                }
                <Grid size={0.5}>
                    <IconButton size="small" color="primary" variant="outlined" onClick={() => handleShow(cow)}><Info sx={{ fontSize: '1.2em' }} /></IconButton>
                </Grid>
                {cow.award_list && cow.award_list.length > 0 &&
                    <Grid size={12}>
                        {cow.award_list.map((a, k) => (
                            <Chip label={`${a.award_name} ${cow[a.award_value] ? cow[a.award_value] : ''}`} color={a.from_other_data ? "primary" : "secondary"} key={k} size="small" />
                        ))}
                    </Grid>
                }
            </Grid>
        )

    } else {
        return <></>

    }
})

const OneSumCow = memo(({ cow, handleShow }) => {
    const { selEvent } = useEvent()
    const cow_data = cow
    if (cow_data) {

        const birthdate = myTimestampToDate(cow_data.birthdate)
        const ev_date = myTimestampToDate(selEvent.event_start)



        return (
            <Grid container sx={{ ...globalstyles.list_row, fontSize: '0.7em', color: cow_data.is_invalid ? '#aaa' : 'black' }}>
                <Grid size={1}>
                    {cow_data.catalog_id}
                </Grid>
                <Grid size={1} flexDirection={"row"} container>
                    <CowtypeBadge cow_type={cow_data.cow_type} />
                    {cow_data.serial}
                </Grid>
                <Grid size={1}>
                    {cow_data.birth}
                </Grid>
                <Grid size={1}>
                    {differenceInMonths(ev_date, birthdate)}
                </Grid>
                <Grid size={1}>
                    {format(birthdate, 'dd/MM/yyyy')}
                </Grid>
                <Grid size={"grow"}>
                    {cow.match_data_list?.map((md, mdk) => (
                        <Box key={mdk}>
                            <b>{md.match_data.name}</b><br />
                            <i>{md.match_data.award_description}</i><br />
                        </Box>

                    ))}
                </Grid>
                <Grid size={1}>
                    {cow.match_data_list?.length > 0 &&

                        cow.match_data_list.map((md, mdk) => (
                            <Box key={mdk}>
                                <i>{md.match_point}</i><br /> <br />
                            </Box>

                        ))}
                </Grid>
                <Grid size={1} sx={{ fontWeight: 'bold' }}>
                    {cow.match_point}
                </Grid>
                <Grid size={0.5}>
                    <IconButton
                        tabIndex={-1} color="primary" size="small" variant="outlined" onClick={() => handleShow(cow)}><Info sx={{ fontSize: '1.2em' }} /></IconButton>
                </Grid>

            </Grid>
        )

    } else {
        return <></>

    }
})



const NotMatchCows = ({ match_cow_list, cow_list, handleShow }) => {
    const c_list = match_cow_list.map(c => c.cow?.id).filter(c => c !== undefined)
    const e_c_list = cow_list.filter(c => !c_list.includes(c.id))
    if (e_c_list.length > 0) {

        return (
            <>
                Soggetti non classificati <Chip label={e_c_list.length} size="small" />
                <Grid container sx={globalstyles.listHeader}>
                    <Grid size={0.5}>

                    </Grid>
                    <Grid size={0.5}>
                        Catalogo
                    </Grid>
                    <Grid size={1} flexDirection={"row"} container>
                        Matricola
                    </Grid>
                    <Grid size={"grow"}>
                        Nome
                    </Grid>
                    <Grid size={"grow"}>
                        Proprietà
                    </Grid>
                    <Grid size={1}>
                        parti
                    </Grid>
                    <Grid size={1}>
                        Età (mesi)
                    </Grid>
                    <Grid size={1}>
                        Data di nascita
                    </Grid>
                    <Grid size={0.5}>
                    </Grid>
                </Grid>
                {e_c_list.map((cow, k) => (
                    <OneSumCow cow={cow} key={k} handleShow={handleShow} />
                ))}

            </>
        )
    }
}
